import { useUpdateAccountSettings } from "@/api/fapinstructor/account/update-account-settings";
import { notifications } from "@mantine/notifications";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { GameBuilderForm } from "./-components/game-generator-form";
import { accountSettingsQueryOptions } from "@/api/fapinstructor/account/get-account-settings";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/game-generator/",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(accountSettingsQueryOptions()),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const accountSettings = Route.useLoaderData();
  const updateAccountSettingsMutation = useUpdateAccountSettings();

  return (
    <GameBuilderForm
      initialValues={accountSettings.gameGeneratorConfig}
      onGenerate={async (values) => {
        try {
          await updateAccountSettingsMutation.mutateAsync({
            ...accountSettings,
            gameGeneratorConfig: values,
          });
          navigate({ to: "/play/game-generator" });
        } catch {
          notifications.show({
            title: "Something went wrong",
            message: "An error occured while trying to save your settings.",
            color: "red",
            autoClose: 10000,
          });
        }
      }}
    />
  );
}
